import { queryOptions } from "@tanstack/react-query";
import type {
  OrgMembersData,
  OrgMembersResponse,
} from "@/app/org-members/types";
import { getCoordinatorApi } from "@/lib/api";
import { orgMembersKeys, previousPageOfSameOrg } from "./query-keys";

type PageParams = {
  organizationId: string;
  limit: number;
  offset: number;
};

const fetchOrgMembers = async ({
  organizationId,
  limit,
  offset,
}: PageParams): Promise<OrgMembersData> => {
  const client = getCoordinatorApi({ organizationId });
  const { data } = await client.get<OrgMembersResponse>("/members", {
    params: { limit, offset },
  });
  return data.data;
};

export const orgMembersQueryOptions = (params: PageParams) =>
  queryOptions<OrgMembersData>({
    queryKey: orgMembersKeys.page(params),
    queryFn: () => fetchOrgMembers(params),
    // Each row's `projects` is derived from project membership, which is mutated
    // on other routes (project members, invitations, project create/delete) that
    // don't invalidate this key. The org overview is this query's only consumer,
    // so refetching on mount keeps the projects column fresh on every visit
    // without coupling every membership mutation to this key.
    refetchOnMount: "always",
    // Paging replaces the whole table. Without this it unmounts to a skeleton on
    // every click; with it the last page stays on screen until the next lands.
    placeholderData: previousPageOfSameOrg(params.organizationId),
  });
